import { z } from "zod";

// Schema compartilhado entre CompulsoryRequest e AdditionRequestTabV2 — antes
// duplicado nos dois CompulsoryModal.tsx (mesmo shape, mesmas mensagens).
// Consolidado aqui em 2026-05-26 pelo follow-up F-C do sub-projeto B.
export const withdrawalSchema = z.object({
  withdrawal_name: z
    .string({ message: "Nome é obrigatório" })
    .min(3, "Mínimo de 3 caracteres"),
  withdrawal_rg: z
    .string({ message: "RG é obrigatório" })
    .min(5, "RG inválido"),
});

export type WithdrawalFormValues = z.infer<typeof withdrawalSchema>;
